import { ReactNode } from "react";
import { useBookingViewOnly } from "./BookingViewOnlyContext";

/**
 * Wraps a step panel's inputs so they're inert when the sheet is read-only (a closed booking). A
 * native `disabled` <fieldset> disables every descendant form control — text inputs, selects,
 * Headless UI listbox buttons, the date-picker's day buttons, sliders, file inputs — in one place,
 * without threading `disabled` through each atom. `display: contents` keeps the panel's own layout
 * intact. Panels still render their Proceed buttons OUTSIDE this wrapper and hide them via
 * `useBookingViewOnly()` (the spec removes them entirely rather than greying them out).
 *
 * Nav buttons (Next/Previous Step) must stay OUTSIDE this wrapper so paging through the finished
 * booking keeps working.
 */
export const ViewOnlyFieldset = ({ children, className }: { children: ReactNode; className?: string }) => {
  const viewOnly = useBookingViewOnly();
  return (
    <fieldset disabled={viewOnly} className={className ?? "contents"}>
      {children}
    </fieldset>
  );
};
